module.exports = __webpack_public_path__ + "media/hint.627d0324.wav";